// extracted by mini-css-extract-plugin
export var legendIndicator = "_g3-1";
export var legendRight = "_g3-0";